<template>
  <div>
    <b-row class="m-0">
        <b-col class="p-0" cols="5">
        <fieldset class="border p-3 mb-3" v-for="(preference_category, index) in params.fields.preference_categories">
            <legend  class="w-auto bg-warning px-2 py-1 text-white rounded border h6">{{preference_category.description}}</legend>
            <b-row>
                <b-col cols="12">
                    <b-list-group>
                        <b-list-group-item v-for="(preference, index_preference) in preference_category.preferences">
                            <b-form-checkbox v-model="preference.is_selected" name="check-button" switch>
                                {{preference.description}}
                            </b-form-checkbox>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>
            </fieldset>
        </b-col>
    </b-row>

      <b-modal v-model="modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
          <social-media-form @save="save"/>
      </b-modal>
  </div>
</template>
<script>

    import SwalMixin from "@/views/mixins/Swal.js";
    import SocialMediaForm from './SocialMediaForm.vue';
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    export default {
        mixins:[SwalMixin],
        components: {NumberFormatComponent,SocialMediaForm},
        props:{
            params: {
                type: Object,
                default: {},
                required: true
            },
        },
        data() {
            return {
                modal:false
            }
        },
        methods:{
            deleteSocialMedia(id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.is_saving=true;
                        this.axios.delete('maintenance/manpowers/social-media/delete',{ data: {id:id} }).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving=false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving=false;
                        });
                    }
                });
                
            },
            save(){
                this.$emit('save');
                this.modal=false;
            },
        }
    }
</script>
